module.exports = __webpack_public_path__ + "img/3.643a0dc3.jpg";